/// <reference path='../_all.ts' />

module user {
  'use strict';

  export class RegisterData {
    constructor(
      public Email: string,
      public Password: string,
      public PasswordRepeat: string,
      public Firstname: string,
      public Lastname: string,
      public Company: string,
      public Country: partner.Country,
      public Language: string,
      public Access: number,
      public Newsletter: boolean,
      public Privacy: boolean,
      public VerteilerId: string
      ) { }
  }
}